import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// import Vuetify from '@/plugins/vuetify';

Vue.use(Vuetify);

export default new Vuetify({
});
